<template>
	<div style="min-height: 100vh;">
		<div style="text-align: center;">
		    <div class="panel" style="max-width: 800px;">
		        <div class="panel-header" >
		            <div v-if="id==0">
		                {{ $t('message.addCustomer') }}
		            </div>
		            <div v-else>
		                {{ $t('message.editCustomer') }}
		            </div>
		        </div>
		        <div class="panel-body" style="min-height: 400px;">
		            <div class="wap-container">
		                <div class="panel">
		                    <div class="panel-body">
		                        <form method="post" enctype="multipart/form-data" class="form form-horizontal" id="form_tag">
		                            <div class="row cl">
		                                <label style="color: #000;" for="_姓名" class="form-label col-xs-4 col-sm-2">
		                                    {{ $t('message.name') }}
		                                </label>
		                                <div class="formControls col-xs-8 col-sm-9">
		                                    <input :placeholder="$t('message.name')" v-model="main.name" id="_姓名" type="text" 
		                                        name="姓名" required autocomplete="off" class="input-text save_tag">
		                                </div>
		                            </div>
		                            <div class="row cl">
		                                <label style="color: #000;" for="_性别" class="form-label col-xs-4 col-sm-2">
		                                    {{ $t('message.gender') }}
		                                </label>
		                                <div class="formControls col-xs-8 col-sm-9">
		                                    <select v-model="main.Gender" id="_性别" name="性别" required class="input-text save_tag">
		                                        <option value="男">{{ $t('message.male') }}</option>
		                                        <option value="女">{{ $t('message.female') }}</option>
		                                    </select>
		                                </div>
		                            </div>
		                            <div class="row cl">
		                                <label style="color: #000;" for="_年龄" class="form-label col-xs-4 col-sm-2">
		                                    {{ $t('message.age') }}
		                                </label>
		                                <div class="formControls col-xs-8 col-sm-9">
		                                    <input :placeholder="$t('message.age')" v-model="main.Age" id="_年龄" type="text" 
		                                        name="年龄" required autocomplete="off" class="input-text save_tag">
		                                </div>
		                            </div>
		                            <div class="row cl">
		                                <label style="color: #000;" for="_联系方式" class="form-label col-xs-4 col-sm-2">
		                                    {{ $t('message.contact') }}
		                                </label>
		                                <div class="formControls col-xs-8 col-sm-9">
		                                    <input :placeholder="$t('message.contact')" v-model="main.Contactinformation" id="_联系方式" 
		                                        type="text" name="联系方式" required autocomplete="off" class="input-text save_tag">
		                                </div>
		                            </div>
		                            <div class="row cl">
		                                <label style="color: #000;" for="_fitter" class="form-label col-xs-4 col-sm-2">
		                                    {{ $t('message.fitter') }}
		                                </label>
		                                <div class="formControls col-xs-8 col-sm-9">
		                                    <input :placeholder="$t('message.fitter')" v-model="main.fitter" id="_fitter" type="text" 
		                                        name="fitter" required autocomplete="off" class="input-text save_tag">
		                                </div>
		                            </div>
		                            <div class="row cl">
		                                <div class="col-xs-8 col-sm-9 col-xs-offset-4 col-sm-offset-3">
		                                    <a class="btn btn-success" @click="back()">{{ $t('message.back') }}</a>
		                                    <input class="btn btn-primary radius ml-10" type="button" @click="save()" :value="$t('message.save')">
		                                </div>
		                            </div>
		                        </form>
		                    </div>
		                </div>
		            </div>
		        </div>
		    </div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'login', // 组件的名称，根据实际情况替换 'YourComponentName'
		data() {
			return {
				id: 0,
				// 在这里定义你的组件数据
				src: "",
				list: [],
				main: {
					
				}
			};
		},
		computed: {
			// 计算属性
		},
		methods: {
			// 方法
			save() {
				var that = this
				$.ajax({
					url: that.URL,
					data: {
						t: "kh_save",
						token: localStorage.getItem('token'),
						id: that.$data.id,
						name: that.$data.main.name,
						Gender: that.$data.main.Gender,
						Age: that.$data.main.Age,
						Contactinformation: that.$data.main.Contactinformation,
						fitter: that.$data.main.fitter
					},
					dataType: "json",
					success(e) {
						that.back();
					}
				})
			},
			init() {
				var that = this
				$.ajax({
					url: that.URL,
					data: {
						t: "msg_init",
						token: localStorage.getItem('token')
					},
					dataType: "json",
					success(e) {
						if (e.pid == 0) {
							that.$router.replace('/login');
						}
						
					}
				})
				$.ajax({
					url: that.URL,
					data: {
						t: "kh_main",
						token: localStorage.getItem('token'),
						id: that.$data.id
					},
					dataType: "json",
					success(e) {
						that.$data.main = e.main;
					}
				})

			}
		},
		created() {
			var that = this
			that.$data.id = this.$route.query.id;;
			// 组件挂载后执行的代码
			that.init()
		},
		mounted() {
			
		}
	}
</script>

<style>
	.row {
		margin-top: 20px;
	}
</style>